const VWO_HOMEPAGE_EXPERIMENT = "HomePageUpdatedV1";
const VWO_PRODUCT_CARDS_EXPERIMENT = "ProductCardsV1";
const VWO_VARIANT_HOMEPAGE_HEADER_NAME = "home_ab_experiment_v1";

// const vwoAccountId = 551982;
const vwoAccountId = 0;

const vwoKeys = {
  [VWO_HOMEPAGE_EXPERIMENT]: {
    // stage: "27e963cdd992519bb07d5b42643477f8",
    // prod: "a418d918594728e8f328d33580294c41",
    stage: "",
    prod: "",
  },
  [VWO_PRODUCT_CARDS_EXPERIMENT]: {
    // stage: "ab7c724fa85bfd2adf03c01f5b741761",
    // prod: "0b9090f7a5bfa899fa40690c4dd964f2",
    stage: "",
    prod: "",
  },
};

const CURRENT_VWO_EXPERIMENTS = [VWO_HOMEPAGE_EXPERIMENT];

const VWO_EXPERIMENT_VARIANTS = {
  VARIANT_A: "nextgen_variant_a",
  VARIANT_B: "nextgen_variant_b",
  VARIANT_C: "nextgen_variant_c",
};

export {
  vwoKeys,
  VWO_HOMEPAGE_EXPERIMENT,
  VWO_VARIANT_HOMEPAGE_HEADER_NAME,
  VWO_EXPERIMENT_VARIANTS,
  CURRENT_VWO_EXPERIMENTS,
  vwoAccountId,
};
